export default {
  routes: [
    {
      name: 'professions',
      path: '/directory/professions',
      component: () => import('./views/TheProfessions.vue'),

    },

    {
      name: 'profession',
      path: '/directory/professions/:uuid',
      component: () => import('./views/TheProfession.vue'),
    },
  ]
}
